module.exports = __webpack_public_path__ + "media/landing_page/bg-bot-67770aa2.jpg";